import { APPOINTMENT_FORM_SUBMIT_ERRORS } from "../../utils/constants";
import { buildUri } from "../../utils/dom";

/**
 * The Appointment Service class keeps track of selected items.
 * It also submits the filled in appointment data to the web services
 */
export class AppointmentService {


    get uri() {
        return buildUri(v24Scheduler.serviceRegion, `/api/scheduler/Appointments`);
    }


    constructor() { }

    async submitAppointment(appointment) {
        try {
          
            const response = await fetch(this.uri, {
                method: "POST",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(appointment)
            })
            return await response.json();

        } catch (e) {
            //TODO: Need to test this - RDM-8208
            console.error(`Can't submit appointment, ${e}`);
            return  {"status":APPOINTMENT_FORM_SUBMIT_ERRORS.networkRequestError};
        }
    }

}
